import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './FooterPages.css';

const Pricing = () => {
    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">
                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">Pricing & Plans</h1>
                    <p className="footer-subtitle">
                        Transparent pricing for Institutions and Professionals. Students always join for free.
                    </p>
                </div>

                <div className="footer-grid-section" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                    {/* Basic Plan */}
                    <div className="footer-glass-card" style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3>Standard Access</h3>
                        <div style={{ fontSize: '2.5rem', color: '#818cf8', marginBottom: '1rem', fontWeight: 'bold' }}>Free</div>
                        <p style={{ marginBottom: '2rem' }}>For Students & Professionals looking to browse.</p>
                        <ul className="footer-info-list" style={{ marginBottom: '2rem', flexGrow: 1 }}>
                            <li>Create a Profile</li>
                            <li>Browse Public Sessions</li>
                            <li>Access Community Forums</li>
                        </ul>
                        <Link to="/register" className="footer-cta-btn" style={{ background: 'transparent', border: '1px solid #6366f1', color: '#c7d2fe', width: '100%' }}>Get Started</Link>
                    </div>

                    {/* Institution Plan */}
                    <div className="footer-glass-card" style={{ border: '1px solid #818cf8', position: 'relative', display: 'flex', flexDirection: 'column', transform: 'scale(1.02)' }}>
                        <div style={{ position: 'absolute', top: '-12px', right: '24px', background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)', color: '#FFFFFF', padding: '4px 12px', borderRadius: '12px', fontWeight: 'bold', fontSize: '0.8rem' }}>POPULAR</div>
                        <h3>Institutional Partner</h3>
                        <div style={{ fontSize: '2.5rem', color: '#818cf8', marginBottom: '1rem', fontWeight: 'bold' }}>Custom</div>
                        <p style={{ marginBottom: '2rem' }}>Tailored for Universities & Colleges.</p>
                        <ul className="footer-info-list" style={{ marginBottom: '2rem', flexGrow: 1 }}>
                            <li>Unlimited Job Postings</li>
                            <li>Advanced Expert Matching</li>
                            <li>Dedicated Account Manager</li>
                            <li>Escrow Payment Protection</li>
                        </ul>
                        <Link to="/contact" className="footer-cta-btn" style={{ width: '100%' }}>Contact Sales</Link>
                    </div>

                    {/* Professional Plan */}
                    <div className="footer-glass-card" style={{ display: 'flex', flexDirection: 'column' }}>
                        <h3>Pro Practitioner</h3>
                        <div style={{ fontSize: '2.5rem', color: '#818cf8', marginBottom: '1rem', fontWeight: 'bold' }}>5%</div>
                        <p style={{ marginBottom: '2rem' }}>Commission per paid engagement.</p>
                        <ul className="footer-info-list" style={{ marginBottom: '2rem', flexGrow: 1 }}>
                            <li>Verified Badge</li>
                            <li>Priority Listing</li>
                            <li>Contract Management</li>
                            <li>Billing & Invoicing Support</li>
                        </ul>
                        <Link to="/register" className="footer-cta-btn" style={{ background: 'transparent', border: '1px solid #6366f1', color: '#c7d2fe', width: '100%' }}>Join as Expert</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pricing;


